import FormCheckboxFieldDark from "@/components/UI/FormCheckboxFieldDark/FormCheckboxFieldDark";

export default function ElementShowTextField(props) {
  const { formValues, setValue, type } = props;
  const { showText } = formValues;

  return (
    <FormCheckboxFieldDark
      label="Show title"
      onChange={() => setValue("showText", !showText, { shouldDirty: true })}
      checked={showText}
      data-testid="element-title-show-text"
      data-analytics={`${type}-checkbox-show-title`}
    />
  );
}
